export default __webpack_public_path__ + "static/media/sponsor-2.7e374001.png";